var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailDashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Character",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.78 25.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill:rgb(255, 255, 255);\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.22,25.39c.05-.05,.09-.11,.15-.15,2.96-2.46,5.92-4.92,8.88-7.38,.06-.05,.12-.09,.17-.13,1.48,1.31,3.53,1.27,4.96,0,.7,.58,1.4,1.16,2.1,1.74,2.31,1.92,4.62,3.84,6.93,5.76,.06,.05,.11,.11,.17,.17H1.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.39,9.37c3.1,2.58,6.21,5.16,9.33,7.76-.46,.39-.91,.76-1.36,1.13-2.59,2.15-5.18,4.31-7.78,6.46-.06,.05-.13,.09-.2,.13,0-5.16,0-10.32,0-15.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.39,9.39v15.49c-3.12-2.59-6.21-5.15-9.32-7.74,3.11-2.58,6.2-5.16,9.32-7.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.3,6.45c.95,.67,1.87,1.33,2.82,2-.95,.79-1.87,1.55-2.82,2.34V6.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.51,6.44v4.36c-.96-.79-1.88-1.56-2.83-2.35,.94-.67,1.87-1.32,2.83-2.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.2,1.7c.79-.5,1.4-1.17,2.33-1.28,.63-.08,1.22,.03,1.75,.37,.43,.27,.84,.59,1.3,.92h-5.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.58,
    y: 7.39,
    width: 2.15,
    height: 3.82
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.07,5.93v5.28h2.14V5.93h-2.14Zm0,0v5.28h2.14V5.93h-2.14ZM4.41,2.63c0,.05-.01,.08-.01,.09,0,2.9,0,5.79,.01,8.67,0,.08,.07,.2,.14,.26,2.2,1.83,4.38,3.66,6.59,5.47,1.1,.91,2.45,.89,3.55-.01,2.18-1.82,4.35-3.62,6.53-5.43,.14-.09,.18-.2,.18-.37-.01-2.8,0-5.61,0-8.43v-.26H4.41Zm5.57,8.85c0,.31-.12,.45-.45,.45h-2.7c-.33,0-.45-.12-.45-.46v-3.25c0-.37,.12-.47,.47-.47h2.66c.33,0,.46,.12,.46,.45v3.29Zm4.47,0c0,.34-.12,.46-.45,.46h-2.68c-.33,0-.46-.12-.46-.45V7.13c0-.35,.12-.46,.47-.47h2.66c.34,.01,.46,.12,.46,.45v4.38Zm4.47-.05c0,.41-.09,.5-.5,.5h-2.6c-.37,0-.47-.11-.47-.49V5.68c0-.37,.11-.47,.47-.47h2.66c.34,0,.45,.12,.45,.46v5.76Zm-2.86-.22h2.14V5.93h-2.14v5.28Zm-8.96-.01h2.15v-2.74h-2.15v2.74Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.07,
    y: 5.93,
    width: 2.14,
    height: 5.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.58,
    y: 7.39,
    width: 2.15,
    height: 3.82
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.11,
    y: 8.46,
    width: 2.15,
    height: 2.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDashWhite);
export default __webpack_public_path__ + "static/media/EmailDashWhite.818f785f5c5760922a53db6364659cef.svg";
export { ForwardRef as ReactComponent };